import { Loader } from '@ui/components/Loader';

import {
  useAdminUpdateClubMutation,
  useClubCardQuery,
} from '@features/club/api/hooks';
import { ClubAdminForm } from '@features/club/ui/ClubAdminForm/ClubAdminForm';

type Props = {
  clubId: string;
  disabled?: boolean;
};
export function ClubAdminFormWidget({ clubId, disabled }: Props) {
  const { data: club } = useClubCardQuery(clubId);
  const { mutateAsync: onSubmit } = useAdminUpdateClubMutation(clubId);

  if (!club) return <Loader centered />;

  return (
    <ClubAdminForm
      club={club}
      onSubmit={onSubmit}
      disabled={disabled}
    />
  );
}
